export default {
  title: "Тарифҳо",
  tariff: "Тариф",
  yourTariff: "Тарифи шумо",
  lessTariffModal: {
    title: "Барориши кортҳои тӯҳфаӣ дар тарифи шумо дастнорас аст",
    subtitle:
      "Барои барориши кортҳои тӯҳфаӣ, ба тариф «Промо» ё «Про+» гузаред",
  },
  lite_p: {
    title: "Лайт",
    list: [
      '<span itemprop="name">Бақайдгирии 1 ташкилот',
      '<span itemprop="name">Эҷоди 5 нуқтаи савдо',
      '<span itemprop="name">Омори содда',
      '<span itemprop="name">Дастрасӣ ба RC KASSA',
      '<span itemprop="name">Муомилоти электронии ҳуҷҷатҳо',
      '<span itemprop="name">Ҳисоббаробаркунӣ 2 маротиба дар як моҳ',
      '<span itemprop="name">Қисмати саволу ҷавобҳо',
    ],
  },

  faq: [
    {
      title: "Рақамисозии муштарӣ чӣ гуна сурат мегирад?",
      text:
        "<p>Барои рақамисозии муштарӣ ба ӯ промокод диҳед. Он метавонад пайванд, QR-рамз ё худи коди рақамисозӣ бошад. Бо истифодаи он муштарӣ бояд дар хидмати муштарии rcpay.ru бақайд шавад.</p>" +
        "<br>" +
        "<p>Таваҷҷӯҳ кунед: барои хондани QR-рамз, муштарӣ бояд камера бо функсияи мутобиқ ё барномаи махсуси QR-сканер дошта бошад.</p>",
    },
    {
      title: "Муштарии «фаъол» чӣ маъно дорад?",
      text:
        "<p>Ин муштарии рақамисозишуда мебошад, ки харид дар муассисаи онлайн ё офлайни экосистемаи RC Group анҷом додааст. Харидҳои онлайн — ин харид дар RC Market, гирифтани сертификатҳо, фаъол кардани хидматҳои Яндекс, хариди тарифҳои корбарӣ мебошад. Харидҳои офлайн — ин харид дар муассисаҳои шаҳр бо истифода аз RC.Kassa мебошад.</p>" +
        "<br>" +
        "<p>Ҳангоми хариди тариф «Корпоративӣ» ҳар як шарик дар аксияи «тахфифи 50%» барои дароз кардани тариф иштирок мекунад. Шарти асосӣ — рақамисозии 500 муштарии «фаъол».</p>",
    },
    {
      title: "Агар тарифро дароз накунам, чӣ мешавад?",
      text: "<p>Дар ин ҳолат, функсионали кабинет то сатҳи тарифи «Базавӣ» маҳдуд мешавад. Шумо танҳо ба қисмати «Рӯйхати муштариён» дастрасӣ доред, вале имкони барориши кортҳои Wallet, ирсоли огоҳиномаҳое, ки Push ном доранд ва дастрасӣ ба хидмати «Чойпулҳои ғайринақдӣ»-ро аз даст медиҳед.</p>",
    },
    {
      title: "Чӣ гуна муштариёни бештарро ҷалб ва рақамисозӣ кунам?",
      text: "<p>Функсияи «Мубодила»-ро барои ҷойгир кардани пайванди реферальӣ дар шабакаҳои иҷтимоӣ истифода баред. Ҳамчунин тейбл-тентҳо, стикерҳо, варақаҳо ва воблерҳоро дар муассисаи худ ҷойгир кунед.</p>",
    },
    {
      title: "Саволи ман нест, чӣ гуна ҷавоб гирам?",
      text:
        "<p>Саволро ба дастгирии техникӣ диҳед. Барои ин нишонаи RC Group-ро дар кунҷи поёнии рост пахш кунед, «Telegram»-ро интихоб кунед ва мушкили худро тавсиф кунед, агар лозим бошад скринҳоро замима намоед. Мутаҳассиси мо ҳатман бо шумо тамос мегирад.</p>" +
        "<br>" +
        "<p>Шумо инчунин метавонед нома ба email: <a href='mailto:hello@rc.company'>hello@rc.company</a> фиристед</br>" +
        "<br>" +
        "Ё бо рақами <b>8 (800) 500-57-62</b> занг занед.</p>",
    },
  ],
  digitizedClientsCounter: "Ҳисобкунаки муштариёни рақамисозишуда",
  activeClientsDigitized: "Муштариёни фаъол рақамисозӣ шудаанд",
  reg500AndMoreClients:
    "Барои гирифтани тахфифи 50% дар дарозкунии тариф, <b>500 ва зиёда муштариёни фаъол</b>-ро дар барнома рақамисозӣ кунед",
  choosePointToGenerateQr:
    "Барои тавлиди пайванд ва QR-рамз барои бақайдгирии муштариёни нав дар RC PAY нуқтаи савдоро интихоб кунед.",
  afterBuyTariffYouCanGenerate:
    "Баъд аз хариди тариф имкони тавлиди пайванд ва QR-рамз барои бақайдгирии муштариёни нав дар RC PAY дастрас мешавад.",
  useLinkAndQrForRegNewClients:
    "Аз пайванд ва QR-рамз барои бақайдгирии муштариёни нав дар RC PAY истифода баред.",
  shareLink: "Пайвандро мубодила кунед",
  anyOtherQuestions: "Саволҳои дигар доред?",
  tariffSuccessPayed: "Тариф «{tariff}» бомуваффақият пардохт шуд",
  tariffPayFromMainEntity:
    "Пардохти тариф аз бақияи воқеии<br />асосии шахси ҳуқуқӣ анҷом дода мешавад.",
  period: "Мӯҳлат",
  cost: "Арзиш",
  discount: "Тахфиф {discount}%",
  totalToPay: "Ҳамагӣ барои пардохт",
  lite: "Лайт",
  promo: "Промо",
  plusPro: "Про+",
  basic: "Базавӣ",
  corporate: "Корпоративӣ",
  popular: "Машҳур",
  advanced: "Пешрафта",
  includesToTariff: "Ба тариф дохил мешавад",
  allInLitePlus: "Ҳама аз тарифи Лайт, иловатан",
  allInPromoPlus: "Ҳама аз тарифи Промо",
  allInBasicPlus: "Ҳама аз тарифи Базавӣ, иловатан",
  forFree: "Ройгон",
  buyTariff: "Харидани тариф",
  tradingPoints: "нуқтаҳои савдо",
  products: "Маҳсулотҳо",
  unlimitProducts: "Маҳсулотҳо бе маҳдудият",
  uCanAddProductsToEMenu:
    "Шумо метавонед {productsCount} маҳсулотро ба каталоги онлайн илова кунед ва аз RC PAY барои онҳо фармоишҳои онлайн гиред",
  canAddUnlimitProductsToEMenu:
    "Шумо метавонед бе маҳдудият маҳсулотро ба каталоги онлайн илова кунед ва аз RC PAY барои онҳо фармоишҳои онлайн гиред",
  twoTgMailingPerWeek: "2 ирсоли паём дар Telegram дар як ҳафта",
  oneTgMailingPerDay: "1 ирсоли паём дар Telegram дар як рӯз",
  canCreateAndSend2NotifyPerWeek:
    "Шумо метавонед 2 огоҳиномаро дар як ҳафта ба муштариёни ҳар нуқтаи савдо дар Telegram-бот эҷод ва ирсол кунед",
  canCreateAndSend1NotifyPerDay:
    "Шумо метавонед 1 огоҳиномаро дар як рӯз ба муштариёни ҳар нуқтаи савдо дар Telegram-бот эҷод ва ирсол кунед",
  basicAnalytics: "Таҳлили базавӣ",
  analyticsHint: "Таҳлил аз рӯи нуқтаҳои савдо ва шахсони ҳуқуқӣ",
  accrualDeducationPoints: "Ҳисоб ва тарҳкунии холҳо дар RC KASSA",
  enablingPaymentMethods: "Пайвасткунии усулҳои пардохт",
  postingYourShopsInRC: "Ҷойгиркунии муассисаҳои шумо дар RC PAY",
  postingYourShopsHint:
    "Бо шарте, ки ба қоидаҳои ҷойгиркунӣ дар RC PAY мувофиқат кунанд<br><br><a target='_blank' href='/docs/Правила размещения.pdf'>Қоидаҳои ҷойгиркунии муассисаҳо дар RC PAY-ро бинед</a>",
  gettingOnlineOrders:
    "Гирифтани фармоишҳои онлайн барои маҳсулот/хизматрасониҳо",
  orderPromotionYourShops: "Фармоиши пешбурди нуқтаҳои савдои шумо",
  advancedAnalytics: "Таҳлили пешрафта",
  advancedAnalyticsHint:
    "Таҳлил аз рӯи нуқтаҳои савдо, шахсони ҳуқуқӣ, кассирҳо, муштариён ва RFM-таҳлил",
  evaluationCashierWork: "Арзёбии кори кассирҳо",
  digitizingClients: "Рақамисозии муштариён",
  accessToClientsList: "Дастрасӣ ба рӯйхати муштариён",
  infoAboutAllClients:
    "Маълумот дар бораи ҳамаи муштариёне, ки муассисаи шуморо боздид карданд, тамосҳояшон, чекҳо ва омор",
  pushNotifyToClientWalletCard:
    "Push-огоҳиномаҳо ба муштариён дар кортҳои Wallet",
  scoringPointsByGroups: "Ҳисобкунии холҳо аз рӯи гурӯҳҳои муштариён",
  uCanSetDifferentPercentAward:
    "Шумо метавонед вобаста ба маблағи хариди муштариён % мукофоти гуногунро муайян кунед",
  distributionRCCard: "Тақсимкунии кортҳои RC",
  designWalletCard: "Тарҳрезии корт Wallet",
  issuingGiftCard: "Барориши кортҳои тӯҳфаӣ",
  priorityMaintenance: "Хидматрасонии афзалиятнок",
  monetizationUpTo30Percent:
    "Монетизатсия то 30% аз мукофоти ҳисобшудаи муштарӣ",
  monetizationHint:
    "Агар шумо имкони гирифтани даромад аз барномаи вафодориро дар доираи фаъолият дошта бошед",
  adding1Entity: "Илова кардани 1 шахси ҳуқуқӣ",
  accessToOperationsHistory: "Дастрасӣ ба таърихи амалиётҳо",
  basicCabinetFunctional: "Функсионали базавии кабинет",
  discountOnTariffRenewal: "Тахфифи 50% барои дарозкунии тариф",
  discountOnTariffRenewalHint:
    "Тахфифи 50% дода мешавад, агар аз охирин хариди тариф шумо 500 ё зиёда муштариёни фаъолро рақамисозӣ карда бошед<br><br><a href='#clients-counter'>Ҳисобкунаки муштариёнро бинед</a>",
  autoConnectIfFreeTariff:
    "Агар тариф пардохтӣ харидорӣ нашуда бошад, худкор пайваст мешавад.",
  tariffBuyingWillAvailableFromDate: "Хариди тариф аз {date} дастрас мешавад",
  entityOnModeration: "Шахси ҳуқуқӣ дар модератсия аст",
  tariffBuyingWillAvailableAfterModeration:
    "Хариди тариф пас аз гузаштани модератсияи шахси ҳуқуқӣ дастрас мешавад.",
  notEnoughMoney: "Пул кофӣ нест",
  tariffPayingFromFactBalance:
    "Пардохти тариф аз бақияи воқеии шахси ҳуқуқии асосӣ анҷом дода мешавад.",
  forBuyingTariffNeedReplenish:
    "Барои харидани тариф «{tariff}» бояд бақияи {entity}-ро на камтар аз {sum} ₽ пур кунед",
  replenishBalance: "Пур кардани бақия",
  canCreate: "Метавонед эҷод кунед",
  forTransitionToTariffConnectWithUs:
    "Барои гузаштан ба тарифи пардохтӣ ба дастгирии техникӣ муроҷиат кунед <a href='mailto:hello@rc.city;>hello@rc.city</a>",
};
